import React from 'react';
import { useNavigate } from 'react-router-dom';

const ChartSelection = ({ user }) => {
  const navigate = useNavigate();

  // Available charts - add more here as we build them
  const charts = [
    {
      id: 'treatment-plan-review',
      name: 'Treatment Plan Review Tracker',
      description: 'Monitor treatment plan review schedules and track compliance timelines',
      icon: '📋',
      category: 'Clinical Outcomes',
      path: '/analytics/treatment-plan-review',
      available: true
    },
    {
      id: 'caseload-diagnosis',
      name: 'Caseload Breakdown by Diagnosis',
      description: 'AI-Powered Clinical Specialization Analysis: Identify practice strengths and optimize resource allocation',
      icon: '🏥',
      category: 'Clinical Outcomes',
      path: '/analytics/caseload-diagnosis',
      available: true
    },
    {
      id: 'individual-phq9-tracker',
      name: 'Individual Client PHQ-9 Tracker',
      description: 'Longitudinal Depression Monitoring: Track individual client PHQ-9 scores over time with AI forecasting and treatment response analysis',
      icon: '📈',
      category: 'Clinical Outcomes',
      path: '/analytics/individual-phq9-tracker',
      available: true
    },
    {
      id: 'individual-gad7-tracker',
      name: 'Individual Client GAD-7 Tracker',
      description: 'Longitudinal Anxiety Monitoring: Track individual client GAD-7 scores over time with AI forecasting and treatment response analysis',
      icon: '🎯',
      category: 'Clinical Outcomes',
      path: '/analytics/individual-gad7-tracker',
      available: true
    },
    {
      id: 'no-show-analysis',
      name: 'No-Show Analysis',
      description: 'Attendance pattern analysis: Identify high-risk clients, intervention strategies, and actionable plans to improve engagement',
      icon: '📅',
      category: 'Practice Operations',
      path: '/analytics/no-show-analysis',
      available: true
    },
    {
      id: 'income-by-month',
      name: 'Income by Month',
      description: 'Practice Revenue Intelligence: Track monthly revenue trends, identify peak and low months, and forecast your financial trajectory with AI-powered analytics',
      icon: '💰',
      category: 'Practice Operations',
      path: '/analytics/income-by-month',
      available: true
    }
  ];

  const handleChartClick = (chart) => {
    if (chart.available) {
      navigate(chart.path);
    }
  };

  return (
    <div className="h-full overflow-y-auto p-8">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Visual Analytics</h1>
          <p className="text-gray-600 mt-2">Select a chart to view or enter new data</p>
        </div>

        {/* Charts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {charts.map((chart) => (
            <div
              key={chart.id}
              onClick={() => handleChartClick(chart)}
              className={`bg-white rounded-xl shadow-md p-6 cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-105 border-2 border-transparent hover:border-blue-500 ${
                !chart.available ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {/* Icon */}
              <div className="text-4xl mb-4">{chart.icon}</div>

              {/* Category Badge */}
              <span className="inline-block px-3 py-1 text-xs font-semibold text-blue-700 bg-blue-100 rounded-full mb-3">
                {chart.category}
              </span>

              {/* Chart Name */}
              <h3 className="text-lg font-bold text-gray-900 mb-2">{chart.name}</h3>

              {/* Description */}
              <p className="text-gray-600 text-sm">{chart.description}</p>

              {/* Status */}
              {!chart.available && (
                <span className="inline-block mt-3 text-xs text-gray-500">Coming soon</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChartSelection;
